import { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const toolbarOptions = [
  "inline",
  "blockType",
  "fontSize",
  "list",
  "textAlign",
  "link", // make sure 'link' is here
  "history",
  "colorPicker",
];

const TextEditor = ({ setValue, defaultValue = "" }) => {
  const [localEditorState, setLocalEditorState] = useState(() => {
    if (defaultValue) {
      const blocksFromHTML = convertFromHTML(defaultValue);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  useEffect(() => {
    if (typeof setValue === "function") {
      const rawContentState = convertToRaw(
        localEditorState.getCurrentContent()
      );
      setValue(draftToHtml(rawContentState));
    }
  }, [localEditorState, setValue]);

  return (
    <div className='bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700'>
      <div className='border-gray-300 dark:border-gray-700 rounded-md overflow-hidden'>
        <Editor
          editorState={localEditorState}
          onEditorStateChange={setLocalEditorState}
          toolbar={{
            options: toolbarOptions,
            link: {
              inDropdown: false,
              showOpenOptionOnHover: true,
              defaultTargetOption: "_blank",
              options: ["link", "unlink"],
            },
          }}
          toolbarClassName='!border-b'
          wrapperClassName='w-full'
          editorClassName='p-2 min-h-[200px] text-gray-800 dark:text-gray-200'
        />
      </div>
    </div>
  );
};

export default TextEditor;
